import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsPlannerDataQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  today: Types.Scalars['timestamptz']['input'];
}>;


export type GetPartsPlannerDataQuery = { __typename?: 'query_root', unassigned_orders: Array<{ __typename?: 'delivery_orders', id: number, order_number: string, dms_order_id?: string | null, part_number?: string | null, recipient_business: string, recipient_name: string, recipient_phone: string, recipient_email?: string | null, notification_preference: string, delivery_address: string, delivery_lat?: number | null, delivery_lng?: number | null, item_description?: string | null, special_instructions?: string | null, priority: string, quantity: number, billing_term?: string | null, has_return_pickup: boolean, return_description?: string | null }>, runs: Array<{ __typename?: 'mobility_runs', id: number, driver_id?: number | null, vehicle_id?: number | null, departure_time?: string | null, status: string, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, delivery_orders: Array<{ __typename?: 'delivery_orders', id: number, order_number: string, part_number?: string | null, recipient_business: string, recipient_name: string, item_description?: string | null, priority: string, quantity: number }> }> }>, drivers: Array<{ __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', display_name: string, avatar_url?: string | null } | null }>, vehicles: Array<{ __typename?: 'mobility_vehicles', id: number, year?: number | null, make: string, model: string, license_plate?: string | null }> };


export const GetPartsPlannerDataDocument = gql`
    query getPartsPlannerData($customerId: bigint!, $today: timestamptz!) {
  unassigned_orders: delivery_orders(
    where: {customer_id: {_eq: $customerId}, run_id: {_is_null: true}, status: {_in: ["pending"]}}
    order_by: [{priority: desc}, {created_at: asc}]
  ) {
    id
    order_number
    dms_order_id
    part_number
    recipient_business
    recipient_name
    recipient_phone
    recipient_email
    notification_preference
    delivery_address
    delivery_lat
    delivery_lng
    item_description
    special_instructions
    priority
    quantity
    billing_term
    has_return_pickup
    return_description
  }
  runs: mobility_runs(
    where: {customer_id: {_eq: $customerId}, product_type: {_eq: "parts_delivery"}, departure_time: {_gte: $today}, status: {_in: ["draft", "scheduled"]}}
    order_by: [{departure_time: asc}]
  ) {
    id
    driver_id
    vehicle_id
    departure_time
    status
    stops(order_by: {stop_order: asc}) {
      id
      stop_order
      delivery_orders {
        id
        order_number
        part_number
        recipient_business
        recipient_name
        item_description
        priority
        quantity
      }
    }
  }
  drivers(
    where: {config: {_contains: {attributes: {mobility_parts: true}}}, user: {users_usertocustomers: {customer_id: {_eq: $customerId}}, users_usertoroles: {roletype: {name: {_eq: "driver"}}}, active: {_eq: true}}}
    order_by: {user: {display_name: asc}}
  ) {
    id
    status
    user {
      display_name
      avatar_url
    }
  }
  vehicles: mobility_vehicles(
    where: {customer_id: {_eq: $customerId}, status: {_neq: "retired"}}
    order_by: [{year: desc}, {make: asc}]
  ) {
    id
    year
    make
    model
    license_plate
  }
}
    `;

/**
 * __useGetPartsPlannerDataQuery__
 *
 * To run a query within a React component, call `useGetPartsPlannerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsPlannerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsPlannerDataQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      today: // value for 'today'
 *   },
 * });
 */
export function useGetPartsPlannerDataQuery(baseOptions: Apollo.QueryHookOptions<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables> & ({ variables: GetPartsPlannerDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>(GetPartsPlannerDataDocument, options);
      }
export function useGetPartsPlannerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>(GetPartsPlannerDataDocument, options);
        }
// @ts-ignore
export function useGetPartsPlannerDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>;
export function useGetPartsPlannerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsPlannerDataQuery | undefined, GetPartsPlannerDataQueryVariables>;
export function useGetPartsPlannerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>(GetPartsPlannerDataDocument, options);
        }
export type GetPartsPlannerDataQueryHookResult = ReturnType<typeof useGetPartsPlannerDataQuery>;
export type GetPartsPlannerDataLazyQueryHookResult = ReturnType<typeof useGetPartsPlannerDataLazyQuery>;
export type GetPartsPlannerDataSuspenseQueryHookResult = ReturnType<typeof useGetPartsPlannerDataSuspenseQuery>;
export type GetPartsPlannerDataQueryResult = Apollo.QueryResult<GetPartsPlannerDataQuery, GetPartsPlannerDataQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (unassigned_orders, runs, drivers, vehicles): returns the full response object.
 * @source {@link src/features/partsDelivery/queries/getPartsPlannerData.query.gql}
 */
export async function getPartsPlannerData(
  variables: GetPartsPlannerDataQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetPartsPlannerDataQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetPartsPlannerDataQuery>(
    GetPartsPlannerDataDocument,
    variables,
    requestOptions
  )
}